<template>
  <CountryPage country="korea" />
</template>